import React from "react";
import { Box, Button, TextField, useMediaQuery } from "@material-ui/core";

export const InspectionCounter = ({
  value,
  onDelta,
  onInputChange,
  isSmall,
}) => {
  const isPhonePortrait = useMediaQuery("(max-width: 480px)");
  const isCompact = useMediaQuery("(max-width: 844px)");

  const handleDelta = (evt, delta) => {
    evt.stopPropagation();
    if (onDelta) onDelta(delta);
  };

  const handleChange = (evt) => {
    evt.stopPropagation();
    if (onInputChange) onInputChange(evt.target.value);
  };

  const handleClickInput = (evt) => {
    evt.stopPropagation();
  };

  if (isPhonePortrait) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        style={{ gap: 8 }}
        component="span"
      >
        <Button
          size="small"
          variant="contained"
          onClick={(evt) => handleDelta(evt, -1)}
        >
          -1
        </Button>
        <TextField
          type="number"
          margin="dense"
          value={value != null ? value : ""}
          onClick={handleClickInput}
          onChange={handleChange}
          inputProps={{ style: { width: 56, textAlign: "center" } }}
        />
        <Button
          size="small"
          variant="contained"
          onClick={(evt) => handleDelta(evt, 1)}
        >
          +1
        </Button>
      </Box>
    );
  }

  // Horizontal layout for everything else
  return (
    <Box
      display="flex"
      alignItems="center"
      style={{ gap: 8 }}
      mr={1}
      component="span"
    >
      {!isSmall && !isCompact && (
        <Button
          size="small"
          variant="contained"
          onClick={(evt) => handleDelta(evt, -2)}
        >
          -2
        </Button>
      )}
      <Button
        size="small"
        variant="contained"
        onClick={(evt) => handleDelta(evt, -1)}
      >
        -1
      </Button>
      <TextField
        type="number"
        margin="dense"
        value={value != null ? value : ""}
        onClick={handleClickInput}
        onChange={handleChange}
        inputProps={{ style: { width: 56, textAlign: "center" } }}
      />
      <Button
        size="small"
        variant="contained"
        onClick={(evt) => handleDelta(evt, 1)}
      >
        +1
      </Button>
      {!isSmall && !isCompact && (
        <Button
          size="small"
          variant="contained"
          onClick={(evt) => handleDelta(evt, 2)}
        >
          +2
        </Button>
      )}
    </Box>
  );
};
